import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Activity, PlayCircle, HeartHandshake, LayoutDashboard, ArrowRight } from 'lucide-react';
interface InvestorSlide4Props {
  isDark?: boolean;
}
export function InvestorSlide4({
  isDark = false
}: InvestorSlide4Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const products = [{
    icon: CheckCircle2,
    name: 'Culture Check™',
    desc: 'Onboarding assessment establishing baseline context',
    color: 'slate'
  }, {
    icon: Activity,
    name: 'Helium Score™',
    desc: 'Quarterly 4C assessment: Clarity, Capacity, Connection, Care',
    color: 'orange'
  }, {
    icon: PlayCircle,
    name: 'Helium Stream™',
    desc: 'Personalized learning content based on results',
    color: 'mint'
  }, {
    icon: HeartHandshake,
    name: 'Helium Care™',
    desc: 'Assessment-driven matching to coaching & therapy',
    color: 'navy'
  }, {
    icon: LayoutDashboard,
    name: 'Executive Dashboard',
    desc: 'Aggregate analytics for HR and executive visibility',
    color: 'charcoal'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-270">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-271">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-272">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-273">
            The Solution
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-274">
            An integrated ecosystem for leadership wellness
          </p>
        </motion.div>

        <div className="relative" data-id="element-275">
          {/* Connecting Line (Desktop) */}
          <div className={`hidden md:block absolute left-[10%] right-[10%] top-8 h-1 rounded-full ${isDark ? 'bg-white/10' : 'bg-heliona-beige'}`} data-id="element-276" />

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 sm:gap-4 relative z-10" data-id="element-277">
            {products.map((product, idx) => {
            const Icon = product.icon;
            return <motion.div key={idx} variants={itemVariants} className="flex flex-col items-center text-center group" data-id="element-278">
                  <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-4 shadow-lg transition-transform group-hover:scale-110 ${isDark ? 'bg-white/10 border border-white/20' : 'bg-white border border-heliona-beige'}`} data-id="element-279">
                    <Icon className={`w-8 h-8 ${isDark ? 'text-white' : `text-heliona-${product.color === 'charcoal' ? 'navy' : product.color === 'mint' ? 'mint-dark' : product.color}`}`} data-id="element-280" />
                  </div>
                  <h3 className={`text-lg font-bold mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-281">
                    {product.name}
                  </h3>
                  <p className={`text-xs sm:text-sm leading-relaxed ${isDark ? 'text-white/60' : 'text-heliona-text-gray'}`} data-id="element-282">
                    {product.desc}
                  </p>

                  {/* Mobile Arrow */}
                  {idx < products.length - 1 && <div className="md:hidden my-4" data-id="element-283">
                      <ArrowRight className={`w-6 h-6 ${isDark ? 'text-white/20' : 'text-heliona-text-gray/20'}`} data-id="element-284" />
                    </div>}
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </motion.div>;
}